import { useEffect, useState } from 'react';

import ValidationError from '@/utils/validation/ValidationError';
import Validator from '@/utils/validation/Validator';

import { NameValidationHook } from './types';

const useNameValidation: NameValidationHook = (name, field = 'Name') => {
	const [isNameValid, setIsNameValid] = useState(false);

	useEffect(() => {
		const validatedName = new Validator(name, field);

		try {
			validatedName.isNotEmpty();

			setIsNameValid(true);
		} catch (error) {
			if (error instanceof ValidationError) {
				setIsNameValid(false);
			}
		}
	}, [name, field]);

	return isNameValid;
};

export default useNameValidation;
